import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { AppRouteModule } from './types';
import { ExtendApp } from 'src/types/interface';

let routerList: AppRouteModule[] = [];

routerList.push(
    {
        name: 'homepage',
        path: '/homepage',
        component: () => import('src/pages/homepage/index.vue'),
    },
    {
        name: 'research_contents',
        path: '/research_contents',
        component: () => import('src/pages/research_contents/index.vue'),
    },
    {
        name: 'system_development',
        path: '/system_development',
        component: () => import('src/pages/system_development/index.vue'),
    },
    {
        name: 'project_results',
        path: '/project_results',
        component: () => import('src/pages/project_results/index.vue'),
    },
    {
        name: 'login',
        path: '/',
        redirect: '/homepage',
    },
    // {
    //     name: 'home',
    //     path: '/home',
    //     component: () => import('src/pages/home/index.vue'),
    // },
    // {
    //     name: 'product_service',
    //     path: '/product_service',
    //     component: () => import('src/pages/product_service/index.vue'),
    // },
    // {
    //     name: 'join_us',
    //     path: '/join_us',
    //     component: () => import('src/pages/join_us/index.vue'),
    // },
    // {
    //     name: 'about_us',
    //     path: '/about_us',
    //     component: () => import('src/pages/about_us/index.vue'),
    // },
    // {
    //     name: 'position_detail',
    //     path: '/position_detail',
    //     component: () => import('src/pages/position_detail/index.vue'),
    // },
    // {
    //     name: 'company_dynamics',
    //     path: '/company_dynamics',
    //     component: () => import('src/pages/company_dynamics/index.vue'),
    // },
    {
        name: 'error',
        path: '/error',
        component: () => import('src/pages/error/index.vue'),
        meta: {
            requireAuth: false,
            showSidebar: false,
        },
    },
);

//2、配置路由
export const router = createRouter({
    history: createWebHistory(),
    routes: routerList as unknown as RouteRecordRaw[],
    // 配置滚动行为
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

// config router
export function setupRouter(app: ExtendApp<Element>) {
    router.beforeEach((to, from, next) => {
        // console.log(`[Router] from ${from.path} to ${to.path}`);
        sessionStorage.setItem('upUrl', JSON.stringify(from.fullPath));

        if (to.matched.some((record) => record.meta.requireAuth)) {
            // 判断该路由是否需要登录权限
            let session = app.config.globalProperties.$Cookies.get('user_session');
            if (session) {
                if (
                    sessionStorage.getItem('routerList') !== null &&
                    sessionStorage.getItem('routerList')?.length !== 0
                ) {
                    next();
                } else {
                    next();
                }
            } else {
                next({
                    path: '/',
                    query: {
                        na: to.fullPath,
                    }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
                });
            }
        } else {
            next();
        }
    });

    app.use(router);
}
